import {useState} from 'react';
import {Box as MuiBox, Typography, Grid, styled, Skeleton} from '@mui/material';
import Avatar from '@jobseeker/lotus/components/Avatar';
import Accordion, {
  AccordionSummary,
} from '@jobseeker/lotus/elements/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import {FaChevronDown} from 'react-icons/fa';
import type {AppState} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';
import {ApplyJobInternal} from '@jobseeker/feature-job/components/UserJobApplication';
import type {} from '@jobseeker/lotus/mui.types';

const Box = styled(MuiBox)(() => ({
  wordWrap: 'break-word',
}));

const Component = () => {
  // const theme = useTheme();
  const {profile} = useSelector((state: AppState) => state.user);

  const [expand, setExpand] = useState(false);

  const toggleAcordion = () => {
    setExpand(prev => !prev);
  };

  return (
    <Accordion
      expanded={expand}
      sx={{
        width: '100%',
        border: '1px solid',
        borderRadius: 4,
        borderColor: 'gray.main',
      }}
    >
      <AccordionSummary
        expandIcon={false}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          width: '100%',
          p: {xxs: 1.5, xs: 2},
          pr: {xxs: 1.5, xs: 3},
        }}
        onClick={toggleAcordion}
      >
        <Grid
          // display={{xxs: 'inline-block', md: 'grid'}}
          justifyContent={'space-between'}
          // width={'100%'}
          container
        >
          <Grid
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Avatar sx={{width: 60, height: 60}} imgUrl={profile.picUrl} />

            <Box>
              <Typography
                sx={{wordBreak: 'break-word'}}
                component={'p'}
                variant="subtitle2"
                fontWeight={600}
              >
                {profile.name || <Skeleton width={160} />}
              </Typography>

              <Typography
                sx={{wordBreak: 'break-word'}}
                component={'p'}
                variant="body3"
              >
                {profile.email || <Skeleton width={160} />}
              </Typography>
              <Typography
                sx={{wordBreak: 'break-word'}}
                component={'p'}
                variant="body3"
              >
                {profile.phone?.replace(/^0+/, '') || <Skeleton width={160} />}
              </Typography>
            </Box>
          </Grid>
          <Grid
            display={'flex'}
            mt={{xxs: 1, md: 0}}
            gap={0.5}
            alignItems={'center'}
            fontSize={12}
          >
            <Typography
              color="primary.main"
              variant="subtitle3"
              component={'span'}
            >
              View Profile
            </Typography>
            <Box
              sx={{
                transform: expand ? 'rotate(180deg)' : 'unset',
                transition: '0.3s ease',
                lineHeight: 0,
              }}
            >
              <FaChevronDown cursor="pointer" />
            </Box>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{p: 0, pb: 0}}>
        <ApplyJobInternal mode="view" source="after-apply" />
      </AccordionDetails>
    </Accordion>
  );
};

export default Component;
